var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestion = function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: false
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 .5c7.473 0 13.5 6.045 13.5 13.54 0 7.496-6.027 13.541-13.5 13.541S.5 21.536.5 14.041C.5 6.545 6.527.5 14 .5Zm0 25.147c6.413 0 11.572-5.174 11.572-11.606 0-6.432-5.16-11.607-11.572-11.607C7.588 2.434 2.43 7.61 2.43 14.041c0 6.431 5.159 11.606 11.571 11.606Zm-.096-7.927c-.675 0-1.06-.583-1.06-1.263l-.05-1.846c0-1.455 1.106-2.135 1.973-2.67l.005-.002c.82-.486 1.205-.778 1.205-1.07 0-1.36-1.302-1.554-2.025-1.554-1.35 0-2.121.875-2.121.875-.434.534-1.206.631-1.784.194-.53-.437-.627-1.215-.193-1.797.53-.68 2.025-1.847 4.098-1.847 3.134 0 4.58 2.04 4.58 4.081 0 1.776-1.382 2.608-2.346 3.188l-.113.067-.289.146c-.482.243-.771.68-.771 1.215l-.049.971c-.048.778-.385 1.312-1.06 1.312Zm1.35 2.38c0 .698-.562 1.264-1.254 1.264a1.258 1.258 0 0 1-1.254-1.264c0-.697.562-1.263 1.254-1.263s1.254.566 1.254 1.264Z",
    fill: "currentColor"
  })));
};
export { SvgQuestion as ReactComponent };
export default __webpack_public_path__ + "65b692829f574a30aa074b5b4e011dc7.svg";